import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[750px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20abstract%20background%20with%20warm%20coral%20and%20soft%20cream%20gradient%2C%20artistic%20comic%20panel%20lines%20subtle%20overlay%2C%20elegant%20modern%20composition%2C%20clean%20minimalist%20aesthetic%2C%20soft%20diffused%20lighting%2C%20no%20text%2C%20no%20characters%2C%20atmospheric%20mood&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫头条背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="container-page flex flex-col items-center text-center pt-20 md:pt-24">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs mb-6">
            <i className="ri-fire-line text-accent-400"></i>
            每日更新 · 全本免费
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight max-w-3xl">
            韩国漫画<span className="text-primary-300">无删减</span>
            <br />
            下拉式阅读新体验
          </h1>
          <p className="mt-5 md:mt-7 text-background-200/90 text-sm md:text-base max-w-xl leading-relaxed">
            海量免费韩漫大全，涵盖恋爱、奇幻、动作、悬疑等热门题材。极速更新，高清画质，下拉流畅阅读，为韩漫爱好者打造极致阅读平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
            <Link
              to="/category/lianai"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-8 py-3 rounded-full whitespace-nowrap cursor-pointer transition-all flex items-center gap-2"
            >
              开始阅读 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/"
              className="border border-background-50/30 hover:border-background-50/60 text-background-50 text-sm font-medium px-8 py-3 rounded-full whitespace-nowrap cursor-pointer transition-all flex items-center gap-2 backdrop-blur-sm"
            >
              <i className="ri-star-line"></i> 热门推荐
            </Link>
          </div>

          <div className="mt-12 md:mt-16 w-full max-w-5xl">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {comics.filter((c) => c.featured).slice(0, 4).map((comic) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.slug}`}
                  className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
                >
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <p className="text-background-50 text-sm md:text-base font-semibold truncate">{comic.title}</p>
                    <p className="text-background-300 text-xs mt-1">{comic.latestChapter}</p>
                  </div>
                  <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-medium whitespace-nowrap">
                    {comic.status}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}